import { Route } from '@/Enums/Routes/Route.enum';
import { IChangeLogHistoryGridRow } from '@/Interfaces/ChangeLogHistory.interface';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { Link } from 'react-router-dom';

const LineItemCell = ({ row }: GridRenderCellParams<IChangeLogHistoryGridRow>) => {
  if (!row.lineItemId || !row.lineItemName) {
    return <span>—</span>;
  }

  const label = `${row.lineItemName} (ID: ${row.lineItemId})`;

  if (!row.campaignId) {
    return <span>{label}</span>;
  }

  return (
    <Link className='text-[#2E87FD]' to={`${Route.CAMPAIGN_MANAGEMENT}/${row.campaignId}?lineItemId=${row.lineItemId}`}>
      {label}
    </Link>
  );
};

export default LineItemCell;
